
export default function CTL_SVG(prop:{d?:string, className?:string}){
  return <>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={prop.className}>
  <title>dots-horizontal</title>
  <path d={prop.d} /></svg>
  </>
}

